import {Button} from '@mantine/core';
import {Link} from 'react-router-dom';
import {OfflinePlaceholder} from 'src/app/offline/OfflinePlaceholder';
import {PathUtility} from 'src/shared/constants/PathBuilder';

// Guidance screen rendered by OfflineRouteGuard; not route-registered. The
// CTA is a router link so it never reloads the SPA while offline.
export const OfflineUnavailablePage = () => (
  <OfflinePlaceholder
    heading="This page is not available offline."
    text="You can keep working in Forms and Inspections while you are offline. Head back to the dashboard to pick a page that works offline."
    cta={
      <Button component={Link} size="lg" to={PathUtility.Dashboard()}>
        Back to Dashboard
      </Button>
    }
  />
);
